import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {EnrollAuthGuard} from './services/enroll-auth.guard';
import {CommonLayoutComponent} from '../shared/components/common-layout/common.component';
import {EnrollCabinetComponent} from 'app/modules/enroll/components/enroll-cabinet/enroll-cabinet.component';
import {EnrollMainComponent} from './components/enroll-main/enroll-main.component';

const routes: Routes = [
  {
    path: '',
    component: CommonLayoutComponent,
    canActivate: [EnrollAuthGuard],
    children: [
      {
        path: '',
        component: EnrollMainComponent
      },
      {
        path: 'main',
        component: EnrollMainComponent
      },
      {
        path: 'cabinet',
        component: EnrollCabinetComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EnrollRoutingModule {
}

export const routedEnrollComponents = [
  EnrollMainComponent
];



// WEBPACK FOOTER //
// ./src/app/modules/enroll/enroll-routing.module.ts